import { AppConfigService } from "../../app-config/app-config.service";
import { ParticipantDTO } from "app/core/models/participant-dto";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  	providedIn: 'root'
})

export class HttpGetParticipantsService {

    public readonly URL: string;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants';
    }

    public obtain$(): Observable<ParticipantDTO[]> {

        const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.participantsAPIKey,
			'Content-Type': 'application/json'
		});

		return this.http.get<ParticipantDTO[]>(
			this.URL,
			{ headers }
		);

    }

}